export default __webpack_public_path__ + "static/media/logowhite.47e31115.svg";